import { getResponseSchema as getConciergeResponse } from "@redotech/redo-support-common/concierge-conversation/rpc/concierge-conversation-schema";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { addConversationTrainingLabel } from "./schema/add-conversation-training-label";
import { createCalendarEntry } from "./schema/calendar/create-calendar-entry";
import { deleteCalendarEntry } from "./schema/calendar/delete-calendar-entry";
import { listCalendarEntries } from "./schema/calendar/list-calendar-entries";
import { updateCalendarEntry } from "./schema/calendar/update-calendar-entry";
import { completeSelfServeOnboarding } from "./schema/complete-self-serve-onboarding";
import { completeSelfServeOnboardingV2 } from "./schema/complete-self-serve-onboarding-v2";
import { conciergeAnalytics } from "./schema/concierge-analytics";
import { conciergeValueReport } from "./schema/concierge-value-report";
import { createAbTest } from "./schema/create-ab-test";
import { endAbTest } from "./schema/end-ab-test";
import { generateConciergeBehavior } from "./schema/generate-concierge-behavior";
import { getAbTest } from "./schema/get-ab-test";
import { getConciergeDashboardProductTableData } from "./schema/get-concierge-dashboard-product-table-data";
import { getConciergeGeneralSettings } from "./schema/get-concierge-general-settings";
import { getConciergeSkillsSettings } from "./schema/get-concierge-skills-settings";
import { getConciergeContextSettings } from "./schema/get-context-settings";
import { getConversationById } from "./schema/get-conversation-by-id";
import { getConversationTrainingLabelsForTeam } from "./schema/get-conversation-training-labels-for-team";
import { getConversations } from "./schema/get-conversations";
import { getConversationsByIds } from "./schema/get-conversations-by-ids";
import { getKnowledgeSourcesForMessage } from "./schema/get-knowledge-sources-for-message";
import { getProductSettings } from "./schema/get-product-settings";
import { iMessageChannelExperimentAnalytics } from "./schema/imessage-channel-experiment-analytics";
import { listAbTests } from "./schema/list-ab-tests";
import { setConciergeContextSettings } from "./schema/set-context-settings";
import { shopperAgentActionsAnalytics } from "./schema/shopper-agent-actions-analytics";
import { shopperAgentInsightsAnalytics } from "./schema/shopper-agent-insights-analytics";
import { supportAnalytics } from "./schema/support-analytics";
import { textConciergeAnalytics } from "./schema/text-concierge-analytics";
import { updateConciergeGeneralSettings } from "./schema/update-concierge-general-settings";
import { updateConciergeSkillsSettings } from "./schema/update-concierge-skills-settings";
import { updateProductSettings } from "./schema/update-product-settings";

export const rpcDefinition = {
  updateConciergeGeneralSettings,
  getConciergeGeneralSettings,
  getConciergeSkillsSettings,
  updateConciergeSkillsSettings,
  getConversations,
  getConciergeContextSettings,
  setConciergeContextSettings,
  getConciergeDashboardProductTableData,
  getProductSettings,
  updateProductSettings,
  getConversationById,
  getConversationsByIds,
  generateConciergeBehavior,
  addConversationTrainingLabel,
  getConversationTrainingLabelsForTeam,
  getKnowledgeSourcesForMessage,
  getConciergeResponse,
  completeSelfServeOnboarding,
  completeSelfServeOnboardingV2,
  conciergeAnalytics,
  conciergeValueReport,
  supportAnalytics,
  textConciergeAnalytics,
  shopperAgentInsightsAnalytics,
  shopperAgentActionsAnalytics,
  iMessageChannelExperimentAnalytics,
  listAbTests,
  getAbTest,
  createAbTest,
  endAbTest,
  listCalendarEntries,
  createCalendarEntry,
  updateCalendarEntry,
  deleteCalendarEntry,
};

export type RedoConciergeRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
